import { request } from '@/utils/request';

/**
 * 获取活动列表
 */
export function getActivityList() {
  return request<API.ActivityItem[]>({
    url: '/seller/sellerActivity/getList',
    method: 'post',
  });
}

/**
 * 加入活动
 */
export function joinActivity(id: number) {
  return request({
    url: '/seller/sellerActivity/joinActivity',
    method: 'post',
    data: { id },
  });
}

/**
 * 退出活动
 */
export function outActivity(id: number) {
  return request({
    url: '/seller/sellerActivity/outActivity',
    method: 'post',
    data: { id },
  });
}
